$(document).on('click', '.custom_subscription_checkbox_container', function() {
    $(this).find('svg').toggleClass('hidden');
});
// $(window).on('load', function() {
//     $('#most_popular_card').trigger('click');
// });